/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Results_FoundInputs */

const en_no_results_found = /** @type {(inputs: No_Results_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No results found`)
};

const nl_no_results_found = /** @type {(inputs: No_Results_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen resultaten gevonden`)
};

/**
* | output |
* | --- |
* | "No results found" |
*
* @param {No_Results_FoundInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const no_results_found = /** @type {((inputs?: No_Results_FoundInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Results_FoundInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_no_results_found(inputs)
	return en_no_results_found(inputs)
});